<template>
<div class="choice">
	<a v-for="(label, choice) in choices"
	   @click.prevent="update(choice)"
	   v-bind:class="{ 'btn-secondary': value == choice }"
	   href="#">
	   {{ label }}
	</a>
</div>
</template>

<script>
export default {
	props: [ 'choices', 'value' ],
	methods: {
		update (choice) {
			this.$emit('input', choice)
		}
	}
}
</script>



// WEBPACK FOOTER //
// toggle.vue?0d3b748d